import {RouteConfig} from 'vue-router';
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue';

import NewslettersCreateStuff from '@/pages/Newsletters-stuff/CreateForm.vue';
import NewslettersPageStuff from '@/pages/Newsletters-stuff/NewsletterPage.vue';
import NewslettersInfoStuff from '@/components/Newsletters-stuff/Page/Page.vue';
import NewslettersListStuff from '@/pages/Newsletters-stuff/NewslettersList.vue';
import NewslettersReadyListStuff from '@/components/Newsletters-stuff/List/ready.vue';
import NewslettersInProgressListStuff from '@/components/Newsletters-stuff/List/inProgress.vue';
import NewslettersCompletedListStuff from '@/components/Newsletters-stuff/List/completed.vue';
import NewslettersCanceledListStuff from '@/components/Newsletters-stuff/List/canceled.vue';

import {
  USER_ROLE_MAILING
} from '@/constants';

// @ts-ignore
import messages from '@/lang/index';

const newslatter: RouteConfig = {
  path: '/newsletters-stuff',
  name: 'newsletters-stuff',
  meta: {
    pageName: messages.common.sidebar_links.newsletters.main,
    access: USER_ROLE_MAILING
  },
  component: DashboardLayout,
  redirect: {name: 'newslettersListStuff'},
  children: [
    {
      path: 'list',
      name: 'newslettersListStuff',
      meta: {
        pageName: messages.common.sidebar_links.newsletters.list,
        access: USER_ROLE_MAILING
      },
      component: NewslettersListStuff,
      redirect: {name: 'newslettersReadyListStuff'},
      children: [
        {
          path: 'ready',
          name: 'newslettersReadyListStuff',
          meta: {
            pageName: messages.common.tabs.ready,
            access: USER_ROLE_MAILING
          },
          component: NewslettersReadyListStuff,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersReadyListStuffPage',
              meta: {
                pageName: messages.common.tabs.ready,
                access: USER_ROLE_MAILING
              },
              component: NewslettersReadyListStuff
            }
          ]
        },
        {
          path: 'inProgress',
          name: 'newslettersInProgressListStuff',
          meta: {
            pageName: messages.common.tabs.in_progress,
            access: USER_ROLE_MAILING
          },
          component: NewslettersInProgressListStuff,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersInProgressListStuffPage',
              meta: {
                pageName: messages.common.tabs.in_progress,
                access: USER_ROLE_MAILING
              },
              component: NewslettersInProgressListStuff
            }
          ]
        },
        {
          path: 'completed',
          name: 'newslettersComplitedListStuff',
          meta: {
            pageName: messages.common.tabs.completed,
            access: USER_ROLE_MAILING
          },
          component: NewslettersCompletedListStuff,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersComplitedListStuffPage',
              meta: {
                pageName: messages.common.tabs.completed,
                access: USER_ROLE_MAILING
              },
              component: NewslettersCompletedListStuff
            }
          ]
        },
        {
          path: 'canceled',
          name: 'newslettersCanceledListStuff',
          meta: {
            pageName: messages.common.tabs.canceled,
            access: USER_ROLE_MAILING
          },
          component: NewslettersCanceledListStuff
        }
      ]
    },
    {
      path: 'create',
      name: 'newslettersCreateStuff',
      meta: {
        pageName: messages.common.sidebar_links.newsletters.create,
        access: USER_ROLE_MAILING
      },
      component: NewslettersCreateStuff,
      children: [
        {
          path: 'page/:page',
          name: 'newslettersCreateStuffPage',
          meta: {
            pageName: messages.common.sidebar_links.newsletters.create_page,
            access: USER_ROLE_MAILING
          },
          component: NewslettersCreateStuff
        }
      ]
    },
    {
      path: ':id',
      name: 'newsletterPageStuff',
      meta: {
        pageName: messages.common.sidebar_links.newsletters.main_staff,
        access: USER_ROLE_MAILING
      },
      component: NewslettersPageStuff,
      props: true,
      redirect: {name: 'newsletterInfoStuff'},
      children: [
        {
          path: 'info',
          name: 'newsletterInfoStuff',
          meta: {
            pageName: messages.common.sidebar_links.newsletters.main_info,
            access: USER_ROLE_MAILING
          },
          component: NewslettersInfoStuff,
          props: true
        },
        {
          path: 'info/page/:page',
          name: 'newsletterInfoStuffPage',
          meta: {
            pageName: messages.common.sidebar_links.newsletters.main_info,
            access: USER_ROLE_MAILING
          },
          component: NewslettersInfoStuff,
          props: true
        }
      ]
    }
  ]
};
export default newslatter;